<template>
    <vue-select
        v-bind="$attrs"
        v-on="$listeners"
        :options="options"
        :placeholder="placeholder"
        :getOptionLabel="getOptionLabel"
    >
        <template v-slot:no-options="{ search, searching }">
            <template v-if="searching">
                Hittade inga resultat på <em>{{ search }}</em>.
            </template>
            <em style="opacity: 0.5;" v-else>Sök på ombud</em>
        </template>
    </vue-select>
</template>
<script>
import VueSelect from '@components/Wrappers/VueSelect';
import apiClient from '@services/ApiClient';
import { debounce } from 'lodash';

export default {
    name: 'ServicePointFilter',
    components: {
        VueSelect,
    },
    props: {
        placeholder: {
            type: String,
            default: 'Inget ombud valt',
        },
        criteria: {
            type: Object,
            default() {
                return {};
            },
        },
        servicePoint: {
            type: Object,
            required: false,
        },
        getOptionLabel: {
            type: Function,
            default(option) {
                const arr = [];
                if (option.address) {
                    arr.push(option.address.name);
                    if (Array.isArray(option.address.address_lines) && option.address.address_lines[0]) {
                        arr.push(option.address.address_lines[0]);
                    }
                    if (option.address.city) {
                        arr.push(option.address.city);
                    }
                } else {
                    arr.push(option.id);
                }
                return arr.join(', ');
            },
        },
    },
    data() {
        return {
            options: [],
        };
    },
    watch: {
        criteria: {
            handler: debounce(function criteriaHandler() {
                const vm = this;
                vm.findServicePoints();
            }, 300),
            deep: true,
        },
    },
    mounted() {
        this.findServicePoints();
    },
    methods: {
        async findServicePoints() {
            await apiClient.post('/vue/shipping/find_nearest_service_point', {
                service_type: 'PN-MPCOLLECT',
                criteria: this.criteria,
            }).then((response) => {
                this.options = response.data.service_points;
            }).catch(() => {
                this.options = [];
            }).finally(() => {
                if (this.servicePoint) {
                    const index = this.options.findIndex((item) => item.id === this.servicePoint.id);
                    if (!(index > -1)) {
                        this.options.unshift(this.servicePoint);
                    }
                }
            });
        },
    },
};
</script>
